import React from 'react';

const AnalyticsContext = React.createContext();
AnalyticsContext.displayName = 'Analytics';

export const { Provider, Consumer } = AnalyticsContext;
export default AnalyticsContext;
